import { FileText, Settings, Zap } from 'lucide-react';
import { SummarySectionCard } from './SummarySectionCard';

export function WorkflowSummary({ data }: { data: any }) {
  return (
    <SummarySectionCard title="10. Workflow & Devis" icon={FileText}>
      <div className="space-y-3">
        <div>
          <p className="text-xs text-gray-500 mb-1">Type de workflow</p>
          <div className="flex items-center gap-2">
            {data.workflow === 'QUOTE_REQUIRED' && (
              <>
                <FileText className="w-4 h-4 text-[#00758d]" />
                <span className="font-semibold text-gray-900">Devis obligatoire</span>
              </>
            )}
            {data.workflow === 'IMMEDIATE' && (
              <>
                <Zap className="w-4 h-4 text-[#00758d]" />
                <span className="font-semibold text-gray-900">Paiement immédiat</span>
              </>
            )}
            {data.workflow === 'APPLICATION' && (
              <>
                <Settings className="w-4 h-4 text-[#00758d]" />
                <span className="font-semibold text-gray-900">Sur demande</span>
              </>
            )}
          </div>
        </div>
        {data.workflow === 'QUOTE_REQUIRED' && (
          <>
            <div>
              <p className="text-xs text-gray-500 mb-1">Délai de réponse</p>
              <p className="font-semibold text-gray-900">48 heures</p>
            </div>
            {data.urgentQuotePrice && (
              <div className="bg-[rgba(142,11,86,0.05)] border border-[rgba(142,11,86,0.2)] rounded-lg p-3">
                <div className="flex items-center gap-2 mb-1">
                  <Zap className="w-4 h-4 text-[#8E0B56]" />
                  <p className="text-sm font-semibold text-[#00303c]">Option devis urgent activée</p>
                </div>
                <p className="text-sm text-[#00303c]">
                  Prix: <strong className="text-[#8E0B56]">{data.urgentQuotePrice.toLocaleString()} FCFA</strong> -
                  Délai: <strong className="text-[#8E0B56]">{data.urgentQuoteDelayHours}h</strong>
                </p>
              </div>
            )}
          </>
        )}
      </div>
    </SummarySectionCard>
  );
}
